import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";

import formatDate from "../utils/formatDate";

import styled from "styled-components";

const PostCard = styled(Card)`
  box-shadow: 1px 4px 4px #aaaaaa;
  cursor: pointer;
  margin: 0.7rem 1.2rem;
`;

const Message = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #0b1436;
`;

const MessageInfo = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

const MessageTime = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #1f2022;
  margin: 0 0.25rem;
`;

const MessageViews = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #1f1f1f;
  margin: 0 0.25rem;
`;

const ViewsDiv = styled.div`
  display: flex;
  align-items: center;
`;

type PostComponentProps = {
  post: { _id: string; body: string; views: number; sentDate: string };
};

const PostComponent = ({ post }: PostComponentProps) => (
  <PostCard data-testid={`message-card-${post.body}`}>
    <Card.Body>
      <Message>{post.body}</Message>
      <MessageInfo>
        <MessageTime>{formatDate(post.sentDate)}</MessageTime>
        <OverlayTrigger
          placement="top-end"
          overlay={
            <Tooltip id="tooltip-top-end">
              Indicates the number of people who have opened the app. It isn't
              about the delivered notifications.
            </Tooltip>
          }
        >
          <ViewsDiv>
            <i className="fa fa-eye"></i>
            <MessageViews>{post.views}</MessageViews>
          </ViewsDiv>
        </OverlayTrigger>
      </MessageInfo>
    </Card.Body>
  </PostCard>
);

export default PostComponent;
